import React from 'react';
import { connect } from 'react-redux';
import LeftNav from '../components/Common/LeftNav';
import { getForms } from '../actions/formActions'

const leftNavContainer = props => <LeftNav {...props} />

const mapStateToProps = state => {
    const { forms = {} } = state;
    const { formJson = {}, fetchingForms = {} } = forms;
    return {
        formJson, fetchingForms,
    }
};

const mapDispatchToProps = dispatch => ({
    getForms(payload) {
        dispatch(getForms(payload))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(leftNavContainer);